import axios from 'axios'
import { Cookies } from 'react-cookie'
import { API_URL, ROOT_URL, errorHandler } from './index'
import { AUTH_USER, AUTH_ERROR, UNAUTH_USER, GET_USER } from '../constants/ActionTypes'

//= ===============================
// Authentication Actions
//= ===============================

const authUser = (response) => {
	return {
		type: AUTH_USER,
		response
	}
}

const fetchUser = (response) => {
	return {
		type: GET_USER,
		payload: response.data
	}
}

export const loginUser = (formProps, closeModal) => {
	return dispatch => {
		let url = `${API_URL}/users/login`
		let data = JSON.stringify({
			email: formProps.email,
			password: formProps.password
		})
		axios.post(url, data, {headers:{'Content-Type':'application/json'}})
		.then((response) => {
			let cookies = new Cookies()
			let d = new Date()
			d.setTime(d.getTime() + (24 * 60 * 60 * 1000))
			cookies.set('token', response.data.token, { path: '/', expires: d })
			cookies.set('user_id', response.data.user_id, { path: '/', expires: d })
			cookies.set('user_img', response.data.user_img, { path: '/', expires: d })
			cookies.set('username', response.data.username, { path: '/', expires: d })
			dispatch(authUser(response))
			closeModal()
		})
		.catch((error) => {
			errorHandler(dispatch, error.response, AUTH_ERROR)
		})
	}
}

export const registerUser = (formProps, callback) => {
	return dispatch => {
		let url = `${API_URL}/users/register`
		let data = JSON.stringify({
			name: formProps.name,
			username: formProps.username,
			email: formProps.email,
			password: formProps.password,
			headline: formProps.headline
		})
		axios.post(url, data, {headers:{'Content-Type':'application/json'}})
		.then((response) => {
			let cookies = new Cookies()
			let d = new Date()
			d.setTime(d.getTime() + (24 * 60 * 60 * 1000))
			cookies.set('token', response.data.token, { path: '/', expires: d })
			cookies.set('user_id', response.data.user_id, { path: '/', expires: d })
			cookies.set('user_img', response.data.user_img, { path: '/', expires: d })
			cookies.set('username', response.data.username, { path: '/', expires: d })
			dispatch(authUser(response))
			if (callback) {
				callback(response.data.user_id)
			} else {
				window.location.href = `${ROOT_URL}`
			}
		})
		.catch((error) => {
			console.log("FAILURE...")
			console.log(error)	
		})
	}
}

export const loadUser = () => (dispatch, getState) => {
	let url = `${API_URL}/users/profile`
	let token = getState().auth.token
	let authorization = "Bearer " + token
	axios.get(url, {headers:{'Authorization': authorization}})
	.then((response) => {
		dispatch(fetchUser(response))
	})
	.catch((error) => {
		console.log(error)	
	})
}

export const updateUser = (formProps, callback) => {
	return (dispatch, getState) => {
		let url = `${API_URL}/users/profile`
		let data = JSON.stringify({
			name: formProps.name,
			username: formProps.username,
			email: formProps.email,
			password: formProps.password,
			headline: formProps.headline,
			profile_picture: formProps.profile_picture
		})
		let token = getState().auth.token
		let authorization = "Bearer " + token
		axios.patch(url, data, {headers:{'Content-Type':'application/json', 'Authorization': authorization}})
		.then((response) => {
			let cookies = new Cookies()
			let d = new Date()
			d.setTime(d.getTime() + (24 * 60 * 60 * 1000))
			cookies.set('user_img', response.data.user_img, { path: '/', expires: d })
			window.location.href = `${ROOT_URL}`
		})
		.catch((error) => {
			console.log("FAILURE...")
			console.log(error)	
		})
	}
}

export const logoutUser = (error) => {
	return (dispatch, getState) => {
		dispatch({ type: UNAUTH_USER, payload: error || '' })
		let cookies = new Cookies()
		cookies.remove('token', { path: '/' })
		cookies.remove('user_id', { path: '/' })
		cookies.remove('user_img', { path: '/' })
		cookies.remove('username', { path: '/' })
		window.location.href = `${ROOT_URL}`
	}
}


// WEBPACK FOOTER //
// ./src/actions/auth.js